import { render, staticRenderFns } from "./historicalApproval.vue?vue&type=template&id=134d084f&scoped=true"
import script from "./historicalApproval.vue?vue&type=script&lang=js"
export * from "./historicalApproval.vue?vue&type=script&lang=js"
import style0 from "./historicalApproval.vue?vue&type=style&index=0&id=134d084f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134d084f",
  null
  
)

export default component.exports